module.exports = __webpack_public_path__ + "img/agrartech_zold.5ad86787.svg";